import styled from "@emotion/styled";
import { Box, Button, Modal } from "@mui/material";

const CARD_PADDING = 16;

export const StyledModal = styled(Modal)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ModalContentContainer = styled(Box)`
  display: flex;
  position: relative;
  min-width: 200px;
  min-height: 200px;
  max-height: 100%;
  max-width: 100%;
  overflow: hidden;
`;

export const ModalCardContainer = styled(Box)`
  display: flex;
  padding: ${CARD_PADDING}px;
  border-radius: 12px;
  overflow: auto;
`;

export const CloseButton = styled(Button)`
  z-index: 10;
  position: absolute;
  gap: 4px;
  top: ${CARD_PADDING}px;
  right: ${CARD_PADDING}px;
`;
